import { useEffect, useState, useRef } from "react";

import { useTranslation } from "contexts";
import { createPostRequest } from "Utils/Common";

import { Card } from 'antd';
import { useNavigate, useParams } from "react-router-dom";

const DirectPaymentResult = () => {
    const { id, response } = useParams();
    
    const translate = useTranslation();
    const navigate = useNavigate();

    const [ payResult, setPayResult ] = useState();
    
    useEffect(() => {
        if( !payResult && !id && !response ) {
            navigate("/p", { replace: true });
        } else if( payResult ){
            navigate("/p/result", { replace: true });
        }

        if( payResult || !id || !response ) return;
    
        createPostRequest("verify_paySession", {
            paysessToken: id,
            returnResponse: response
        })
            .then((resp) => resp.data)
            .then((resp) => {
                let result = {};
                if (!resp.success) {
                    result = { status: "ERR" };
                } else result = { status: resp.pay_status, amount: resp.pay_amount, currency: resp.pay_currency };
    
                setPayResult(result);
            })
            .catch((err) => {
                console.error(err);
                navigate("/p", { replace: true, state: { message: ["HomeModalPaidErrorHasOccurred", "HomeModalPaidPleaseTryAgainLater"] }
                });
            });
    }, [payResult, id, response, navigate]);
    
    return(
        <>
            { payResult &&
                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 20px)' }}>
                    <Card 
                        className="text-center" 
                        classNames={{
                            body: 'd-flex flex-column justify-content-center align-items-center'
                        }}
                        style={{
                            width: 'clamp(300px, 60vw, 700px)',
                            height: 'clamp(100px, 10vh, 150px)'
                        }}
                        styles={{
                            body: {
                                height: '100%'
                            }
                        }}
                    >
                        { 
                            payResult.status === 'OK'
                            ?   
                                <>
                                    <div>{translate("MiscYourPaymentOf")} { payResult.amount } { payResult.currency } { translate("MiscIsConfirmed").toLowerCase() }.</div>
                                    <div>{ translate("MiscWeThankYou") }.</div>
                                </>
                            :
                            payResult.status === 'FAIL'
                            ?
                                <div>{ translate("HomeModalPaidPaymentFailed") } { translate("HomeModalPaidPleaseRepeatOperationOrContactUs") }</div>
                            :
                            payResult.status === 'NONE'
                            ?
                                <div>{ translate("HomeModalPaidOperationCancelled") }.</div>
                            :
                                <div>{ translate("HomeModalPaidErrorHasOccurred") } { translate("HomeModalPaidPleaseContactUs") }.</div>
                        }
                    </Card>
                </div>
            }
        </>
    );
}

export default DirectPaymentResult;